import { render, staticRenderFns } from "./pertProduit.vue?vue&type=template&id=1c0263d1&"
import script from "./pertProduit.vue?vue&type=script&lang=js&"
export * from "./pertProduit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports